import { CUSTOMER_SIGNUP, REQUEST_PLATFORM_ACCESS, CUSTOMER_CONFIRM_SIGNUP } from './RegisterActions';
import { Map } from 'immutable';


let defaultState = new Map({
  isFetching: false,
  error: false,
  signupSuccess: false,
  data: []
});

export default (state = defaultState, action) => {
  switch (action.type) {
    case CUSTOMER_SIGNUP.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        email: action.email,
        organization: action.organization,
        error: false
      }));
    case CUSTOMER_SIGNUP.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        signupSuccess: true,
        data: action.payload
      }));
    case CUSTOMER_SIGNUP.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
};

export const platformAccess = (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_PLATFORM_ACCESS.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false
      }));
    case REQUEST_PLATFORM_ACCESS.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        signupSuccess: true,
        data: action.payload
      }));
    case REQUEST_PLATFORM_ACCESS.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        signupSuccess: false,
        error: action.error
      }));
    default:
      return state;
  }
};


export const customerConfirmSignup = (state = new Map({
  isFetching: false,
  error: false,
  data: []
}), action) => {
  switch (action.type) {
    case CUSTOMER_CONFIRM_SIGNUP.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false
      }));
    case CUSTOMER_CONFIRM_SIGNUP.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case CUSTOMER_CONFIRM_SIGNUP.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/containers/Authentication/RegisterReducer.js